import { useEffect, useState } from 'react'

export enum MessageType {
  Success,
  Error
}

export type Message = {
  text: string
  type: MessageType
}

export type Props = {
  message: Message
  className?: string
}

export default function MessageComponent({ message, className }: Props): JSX.Element {
  const [text, setText] = useState<string>(message?.text)

  useEffect(() => {
    setText(message?.text)

    const messageTimeout = setTimeout(() => {
      setText('')
    }, 5000)

    return () => clearTimeout(messageTimeout)
  }, [message])

  if (!message || !text) {
    return null
  }

  return (
    <div className={`${message.type == MessageType.Success ? 'success-message' : 'error-message'} ${className}`}>
      <div dangerouslySetInnerHTML={{ __html: message.text }}></div>
    </div>
    )
}